import OtherProjectItem from "./OtherProject";
import * as OtherProject from "./otherProjectStyles";

export default function OtherProjectContainer() {
    
    const projectList = [
        
        {   
            title: "KnowYourPlate",
            photoUrl: "/knowyourplate.gif",
            description: "The thesis that represented FEU Tech for an international CS thesis conference. It is a mobile application that can record users’ diet and predict health diseases using Machine Learning. ",
            technologies: ["Flutter", "Firebase", "Bloc"],
            github: "https://github.com/DauntlessDev/knowyourplate",
        },
        {   
            title: "Tinkler",
            photoUrl: "/tinkler.gif",
            description: "It is social media app which is also built with flutter with light and dark mode. With this app, users can express themselves and update their followers about their day in different ways. ",
            technologies: ["Flutter", "Firebase", "Cache"],
            github: "https://github.com/DauntlessDev/Tinkler-App",
        },
        {   
            title: "Bizz",
            photoUrl: "/bizz.gif",
            description: "It is e-commerce app which is built with flutter and dart. This is an app where users can quickly buy clothes that they like in seconds. Users can also start their own shop and sell their clothes by becoming a seller member. ",
            technologies: ["Flutter", "Firebase", "Stacked"],
            github: "https://github.com/DauntlessDev/Bizz_flutter",
        },
    ]
    

  return (
    <OtherProject.Container data-aos="fade-up">

        <OtherProject.SectionTitle>Other Interesting Projects</OtherProject.SectionTitle>
        <OtherProject.SectionSubTitle href="https://github.com/DauntlessDev?tab=repositories" target="_blank">view more projects (75+)</OtherProject.SectionSubTitle>
        <OtherProject.ProjectListContainer>
                {projectList &&
                    projectList.map((item, index) => <OtherProjectItem project = {item}  key={index}/> 
                )}
        </OtherProject.ProjectListContainer>
    </OtherProject.Container>
  );
}
